export const EmploymentTypeVI = {
  "EmploymentTypeAdd": {
    "EmploymentTypeAdd": "Thêm hình thức làm việc ",
    "EmploymentTypeEdit": "Sửa hình thức làm việc",
    "EmploymentTypeDelete": "Xoá hình thức làm việc",
    "ListEmploymentType": "Danh sách hình thức làm việc",
    "EmploymentType" : "Hình thức làm việc "
  },
  "EmploymentTypeTitle": {
    "name" : "Tên hình thức làm viêc",
    "status" : " Trạng thái ",
    "active" : "Hoạt động",
    "inactive" : "Không hoạt động"
  },
  "placeholderEmploymentType": {
    "name" : "Tên hình thức làm việc"
  },
  "buttonEmploymentType": {
    "buttonSubmit": "Tạo mới",
    "buttonUpdate": "Sửa",
    "buttonCancel": "Hủy Bỏ"
  },
  "NotificationEmploymentType": {
    "edit": "Sửa dữ liệu thành công...",
    "add": "Thêm dữ liệu thành công...",
    "delete": "Xóa dữ liệu thành công...",
    "Liquidation": "Cập nhật trạng thái thành công...",
    "question": " Bạn có muốn xóa không ? ",
    "title" : "sửa hình thức làm việc",
    "required" : " là yêu cầu!"
  }
}